<template>
  <div :value="index" @click="updateSectionid">
    <div v-if="sectionStates > 0" class="topic isstar">
      <div class="star-count">
        <img src="../assets/img/star_small_counter.png" />
        <p>{{sectionStates}}</p>
      </div>
      <div class="topic-content">
        <img :src="require(`../assets/img/topic_${section_name}.png`)" />
        <p>{{ section_name }}</p>
      </div>
    </div>
    <div v-else class="topic">
      <div class="topic-content">
        <img :src="require(`../assets/img/topic_${section_name}.png`)" />
        <p>{{ section_name }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['index', 'section_name', 'sectionStates'],
  methods: {
    updateSectionid () {
      this.$store.dispatch('sendUserSection', this.index + 1)
      this.$store
        .dispatch('loadArticleState', this.index + 1)
        .then(() => this.$router.push('/game/news'))
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/categoryItem.vue